import { render, staticRenderFns } from "./TempPassword.vue?vue&type=template&id=12dd6a82&"
import script from "./TempPassword.vue?vue&type=script&lang=js&"
export * from "./TempPassword.vue?vue&type=script&lang=js&"
import style0 from "./TempPassword.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports